import React, { ReactNode } from 'react';
import { DropEvent, DropzoneProps, FileRejection, useDropzone } from 'react-dropzone';

import { SxProps, Typography } from '@mui/material';
// import FILE_UPLOAD_ACCEPTED_TYPES from 'components/FileUpload/constants/types';
import useSingleFileDrop from 'components/FileUpload/hooks/useSingleFileDrop';

import { StyledSimpleFileUploadWrap } from './styled';

interface PropsType extends Omit<DropzoneProps, 'children'> {
	name: string;
	children: ReactNode;
	maxSize: number;
	sx?: SxProps;
}

function SimpleFileUpload({
	name,
	children,
	maxSize,
	onDropRejected,
	sx,
	// accept = FILE_UPLOAD_ACCEPTED_TYPES.IMAGE,
	...props
}: PropsType) {
	const { onDrop, onReject, error, isLoading } = useSingleFileDrop({ name });

	const handleDropRejected = (rejectedFiles: FileRejection[], even: DropEvent) => {
		onReject(rejectedFiles, maxSize);
		if (onDropRejected) {
			onDropRejected(rejectedFiles, even);
		}
	};

	const { getRootProps, getInputProps } = useDropzone({
		onDropAccepted: onDrop,
		onDropRejected: handleDropRejected,
		maxSize: maxSize * 1024 * 1024,
		...props,
	});

	return (
		<StyledSimpleFileUploadWrap
			{...getRootProps()}
			sx={{
				...(sx || {}),
				...(isLoading && { pointerEvents: 'none', opacity: 0.5 }),
			}}
		>
			<input {...getInputProps()} />
			{children}
			{error && <Typography variant="body2">{error}</Typography>}
		</StyledSimpleFileUploadWrap>
	);
}

export default SimpleFileUpload;
